import React, { Component } from "react";
import CoverSlide from "./CoverSlide";
import Layout1 from "./Layout1";
import Layout2 from "./Layout2";
import Layout3 from "./Layout3";
import Layout4 from "./Layout4";
import Layout5 from "./Layout5";
import Layout6 from "./Layout6";
import Layout7 from "./Layout7";
import Layout8 from "./Layout8";
import Layout9 from "./Layout9";
import Layout10 from "./Layout10";
import Layout11 from "./Layout11";
import Layout12 from "./Layout12";
import ThankingSlide from "./ThankingSlide";
import QuestionsSlide from "./QuestionsSlide";
import ConclusionSlide from "./ConclusionSlide";
import ExtraSlide from "./ExtraSlide";

export const LAYOUTS = {
  LAYOUT_0: "LAYOUT_0",
  LAYOUT_1: "LAYOUT_1",
  LAYOUT_2: "LAYOUT_2",
  LAYOUT_3: "LAYOUT_3",
  LAYOUT_4: "LAYOUT_4",
  LAYOUT_5: "LAYOUT_5",
  LAYOUT_6: "LAYOUT_6",
  LAYOUT_7: "LAYOUT_7",
  LAYOUT_8: "LAYOUT_8",
  LAYOUT_9: "LAYOUT_9",
  LAYOUT_10: "LAYOUT_10",
  LAYOUT_11: "LAYOUT_11",
  LAYOUT_12: "LAYOUT_12",
  THANKING_SLIDE: "THANKING_SLIDE",
  QUESTIONS_SLIDE: "QUESTIONS_SLIDE",
  CONCLUSION_SLIDE: "CONCLUSION_SLIDE",
  EXTRA_SLIDE: "EXTRA_SLIDE"
};

export class LayoutFactory extends Component {
  render() {
    const { layoutType } = this.props;

    // eslint-disable-next-line default-case
    switch (layoutType) {
      case LAYOUTS.LAYOUT_0: {
        return <CoverSlide {...this.props} />;
      }

      case LAYOUTS.THANKING_SLIDE: {
        return <ThankingSlide {...this.props} />;
      }

      case LAYOUTS.QUESTIONS_SLIDE: {
        return <QuestionsSlide {...this.props} />;
      }

      case LAYOUTS.CONCLUSION_SLIDE: {
        return <ConclusionSlide {...this.props} />;
      }

      case LAYOUTS.EXTRA_SLIDE: {
        return <ExtraSlide {...this.props} />;
      }

      case LAYOUTS.LAYOUT_1: {
        return <Layout1 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_2: {
        return <Layout2 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_3: {
        return <Layout3 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_4: {
        return <Layout4 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_5: {
        return <Layout5 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_6: {
        return <Layout6 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_7: {
        return <Layout7 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_8: {
        return <Layout8 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_9: {
        return <Layout9 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_10: {
        return <Layout10 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_11: {
        return <Layout11 {...this.props} />;
      }

      case LAYOUTS.LAYOUT_12: {
        return <Layout12 {...this.props} />;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/LayoutFactory.js